<!-- Modal mejorado para mostrar QR de receta -->
<div class="modal-qr-container">
  <div class="modal-qr-header">
    <span class="modal-qr-title">
      <mat-icon class="modal-qr-icon" aria-hidden="true">qr_code_scanner</mat-icon>
      Presenta este codigo en la farmacia
    </span>
    <button (click)="dialogRef.close()" aria-label="Cerrar" class="modal-qr-close" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-qr-body">
    <div class="modal-qr-wrapper">
      <img [src]="'data:image/png;base64,' + qrCode" class="modal-qr-img" alt="QR Receta">
    </div>
    <div class="qr-hint">* Asegurate de que el codigo sea legible y sin reflejos.</div>
  </div>
</div>
